var _circle, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLevelUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 31,
    fill: "url(#paint0_linear_889_29030)",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5833 15.4167H41.4167V13.3333C41.4167 12.1875 40.4792 11.25 39.3333 11.25H22.6667C21.5208 11.25 20.5833 12.1875 20.5833 13.3333V15.4167H16.4167C14.125 15.4167 12.25 17.2917 12.25 19.5833V21.6667C12.25 26.9792 16.25 31.3125 21.3958 31.9583C22.7083 35.0833 25.5208 37.4375 28.9167 38.125V44.5833H22.6667C21.5208 44.5833 20.5833 45.5208 20.5833 46.6667C20.5833 47.8125 21.5208 48.75 22.6667 48.75H39.3333C40.4792 48.75 41.4167 47.8125 41.4167 46.6667C41.4167 45.5208 40.4792 44.5833 39.3333 44.5833H33.0833V38.125C36.4792 37.4375 39.2917 35.0833 40.6042 31.9583C45.75 31.3125 49.75 26.9792 49.75 21.6667V19.5833C49.75 17.2917 47.875 15.4167 45.5833 15.4167ZM16.4167 21.6667V19.5833H20.5833V27.5417C18.1667 26.6667 16.4167 24.375 16.4167 21.6667ZM45.5833 21.6667C45.5833 24.375 43.8333 26.6667 41.4167 27.5417V19.5833H45.5833V21.6667Z",
    fill: "url(#paint1_linear_889_29030)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M30.9998 27.9684L34.3065 29.8866C34.9121 30.2382 35.6531 29.7185 35.4938 29.0612L34.6173 25.454L37.5415 23.0236C38.0754 22.5804 37.7886 21.7397 37.0874 21.6862L33.2388 21.3729L31.7329 17.9643C31.462 17.3452 30.5377 17.3452 30.2668 17.9643L28.7608 21.3652L24.9123 21.6786C24.2111 21.7321 23.9242 22.5727 24.4581 23.016L27.3824 25.4463L26.5059 29.0536C26.3465 29.7109 27.0875 30.2306 27.6931 29.879L30.9998 27.9684Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_889_29030",
    x1: 39.9209,
    y1: 62,
    x2: 20.3668,
    y2: 6.85466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3B14E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_889_29030",
    x1: 36.3957,
    y1: 48.75,
    x2: 24.5686,
    y2: 15.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3B14E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE51"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevelUpIcon);
export default __webpack_public_path__ + "static/media/levelUpIcon.e72250cc8c01a1248e83811c2d1c1a9f.svg";
export { ForwardRef as ReactComponent };